import actions from './actions';

const {
  FETCH_TASKS_BEGIN, FETCH_TASKS_SUCCESS, FETCH_TASKS_ERR,
  FETCH_VERBIAGES_BEGIN, FETCH_VERBIAGES_SUCCESS, FETCH_VERBIAGES_ERR,
  COMPLETE_TASK_BEGIN, COMPLETE_TASK_SUCCESS, COMPLETE_TASK_ERR,
} = actions;

const initState = {
  loading: false,
  error: null,
};

const ManageTasksReducer = (state = initState, action) => {
  const { type, data } = action;
  switch (type) {
    case FETCH_TASKS_BEGIN:
    case FETCH_VERBIAGES_BEGIN:
    case COMPLETE_TASK_BEGIN:
      return { ...state, loading: true };
    case FETCH_TASKS_SUCCESS:
    case FETCH_VERBIAGES_SUCCESS:
    case COMPLETE_TASK_SUCCESS:
      return { ...state, loading: false };
    case FETCH_TASKS_ERR:
    case FETCH_VERBIAGES_ERR:
    case COMPLETE_TASK_ERR:
      return { ...state, loading: false, error: data };
    default:
      return state;
  }
};

export default ManageTasksReducer;
